import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image1 from "../assests/image1.png";
function Experience() {
  return (
    <Container className='mb-5 mt-5' style={{paddingTop:"20px"}}>
        <Row id="experience">
        <h2 className='text-white mb-3'data-aos="fade-right"><span className="color">02.&nbsp; &nbsp;</span>My Professional Experience</h2>
            <Col lg={6} md={6} sm={12} xs={12}>
            <div className='padd'>
            <p className='text-white fs-5 ' data-aos="fade-right">Software Engineer - Full Stack  <span className="color" > @  DevSecEngOps Community</span></p>
           <Row>
            <Col lg={1} md={1} sm={1} xs={2} data-aos="fade-right">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8}  md={9} sm={10} xs={10} data-aos="fade-right">
            <p className="color2 font2 mb-3">Built a scalable SAAS application using React JS, delivering a feature-rich and intuitive user experience.</p></Col>
          <Col></Col>
           </Row>
           <Row>
            <Col lg={1} md={1} sm={1} xs={2} data-aos="fade-right">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8} md={9} sm={10} xs={10} data-aos="fade-right">
            <p className="color2 font2 mb-3"> Implemented thorough API testing like Docker, ensuring the stability and reliability of the application.</p></Col>
          <Col></Col>
           </Row>
           <Row>
            <Col lg={1} md={1} sm={1} xs={2} data-aos="fade-right">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8} md={9} sm={10} xs={10} data-aos="fade-right">
            <p className="color2 font2 mb-3">Developed a data scraping solution for extracting valuable information from external sources, enhancing data integration capabilities.</p></Col>
           <Col></Col>
           </Row>
           <Row>
            <Col lg={1}  md={1} sm={1} xs={2} data-aos="fade-right">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8}  md={9} sm={10} xs={10} data-aos="fade-right">
            <p className="color2 font2 mb-3">Efficiently integrating DevSec practices into timely project delivery.Balancing speed and security for optimal outcomes.</p></Col>
           <Col></Col>
           </Row>
          </div>
            </Col>
            
            <Col lg={6} md={6} sm={12} xs={12}>
            <div className='padd'>
            <p className='text-white fs-5 ' data-aos="fade-left">Software developer - Frontend developer <span className="color" > @  Artflix Design Company</span></p>
           <Row>
            <Col lg={1} md={1} sm={1} xs={2}  data-aos="fade-left">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8}  md={9} sm={10} xs={10}  data-aos="fade-left">
            <p className="color2 font2 mb-3">Led a team in the development of the company website's frontend using ReactJS, incorporating animations.</p></Col>
          <Col></Col>
           </Row>
           <Row>
            <Col lg={1} md={1} sm={1} xs={2} data-aos="fade-left">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8}  md={9} sm={10} xs={10}  data-aos="fade-left">
            <p className="color2 font2 mb-3"> Coordinated tasks, managed deadlines, and maintained open communication among team members to ensure project milestones were met.</p></Col>
          <Col></Col>
           </Row>
           <Row>
            <Col lg={1}  md={1} sm={1} xs={2} data-aos="fade-left">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8}   md={9} sm={10} xs={10} data-aos="fade-left">
            <p className="color2 font2 mb-3">Implemented efficient development and deployment strategies, resulting in streamlined processes .</p></Col>
           <Col></Col>
           </Row>
           <Row>
            <Col lg={1}  md={1} sm={1} xs={2} data-aos="fade-left">
            <img src={Image1} width={30}  alt="next-icon"></img>
            </Col>
            <Col lg={8}  md={9} sm={10} xs={10}>
            <p className="color2 font2 mb-3"  data-aos="fade-left">ECollaborated with designers and backend developers to create cohesive and visually appealing web applications.</p></Col>
           <Col></Col>
           </Row>
          </div>
            </Col>
        </Row>
     </Container>
  )
}

export default Experience
